// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"V8-z"};